export const RenameFileModal: string = 'RenameFileModal';
